import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import talks from '../data/talks.yml'

function PatronTalk(props) {
  const talk = talks[props.talkId];
  
  return (
    <div className='talk patron'>
      <div>
        <span className='type'>{talk.type}</span>
        <h2 className='title'>{talk.title}</h2>
      </div>
      { talk.image &&
        <div className='patron-image-container' >
          <img src={talk.image} />
        </div> }
      <span className='speaker-name'>{talk.name}</span>
      <div className='elevator-pitch'>{talk.elevator_pitch}</div>
    </div>
  )
}

PatronTalk.propTypes = {
  talkId: PropTypes.string
}

PatronTalk.defaultProps = {
  talkId: ''
}

export default PatronTalk
